export default __webpack_public_path__ + "img/35355831b0814d7d4b5a0167a8325a7e.png";